/* eslint-disable import/no-cycle */
import { all, call } from 'redux-saga/effects';

import LocationsWatch from 'modules/location/sagas';
import authWatch from 'modules/auth/sagas';
import locationStationWatch from 'modules/location-station/sagas';
import meWatch from 'modules/me/sagas';
import navWatch from 'modules/nav/sagas';
import regionsWatch from 'modules/regions/sagas';
import { routinePromiseWatcherSaga } from 'redux-saga-routines';
import selectVideoWatch from 'modules/form/select-video/sagas';
import { spawn } from 'redux-saga-test-plan/matchers';
import stationEquipmentsWatch from 'modules/station-equipments/sagas';
import stationsWatch from 'modules/stations/sagas';
import videoWatch from 'modules/video/sagas';
import staffWatch from 'modules/staff/sagas';
import workoutProgramWatch from 'modules/workout-program/sagas';

function* rootSaga() {
  // eslint-disable-next-line no-useless-catch
  try {
    yield all([
      // external
      call(routinePromiseWatcherSaga),
      spawn(navWatch),
      // app
      call(authWatch),
      call(meWatch),
      call(videoWatch),
      call(regionsWatch),
      call(stationsWatch),
      call(LocationsWatch),
      call(locationStationWatch),
      call(selectVideoWatch),
      call(stationEquipmentsWatch),
      call(workoutProgramWatch),
      call(staffWatch),
    ]);
  } catch (error) {
    throw error;
  }
}

export default rootSaga;
